<template>
  <GlobalContainer
    class="m-layout tw-relative tw-box-border min-h-screen"
    :class="[`page-${$route.name}`, $route.meta.theme || '']"
  >
    <template v-if="!isAppWebview">
      <DownloadApp v-if="$route.meta.requiresDownload" />
      <!-- 重要通知 -->
      <WarningMessage
        v-if="$route.meta.requiresNotice && noticeMessage"
        class="m-noticeMessage-message"
        :message="noticeMessage"
      />

      <LayoutHeader
        v-if="!$route.meta.hideHeader"
        class="m-layout-header"
        :has-top-bubble="$route.meta.requiresTopBubble"
      />
    </template>

    <keep-alive>
      <FirstNavs v-if="$route.meta.requiresFirstNavs" />
    </keep-alive>

    <Broadcast
      v-if="$route.meta.requiresBroadcast && broadcastList.length"
      :record-list="broadcastList"
    />
    <img
      v-if="pageLoading"
      src="~public/images/loading.svg"
      style="display: block; width: 50px; margin: 67px auto;"
      alt=""
    >
    <keep-alive
      :max="9"
      :include="cacheComponentsList"
    >
      <router-view
        v-show="!pageLoading"
        class="m-main tw-w-full tw-min-h-screen"
      />
    </keep-alive>
    <Betslip
      v-if="$route.meta.requiresBetslip && loadedConfig"
      :source="$route.meta.source"
    />
  </GlobalContainer>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useAppStore } from '@ms/stores/app'
import { useAuthStore } from '@ms/stores/auth'
import { useMatchLabelsStore } from '@ms/stores/matchLabels'
import { useGlobalConfigStore } from '@ms/stores/globalConfig'
import GlobalContainer from '@ms/components/GlobalContainer.vue'
import { subUserPush, unsubUserPush } from 'wap/components/PushPopup'
import DownloadApp from './pagelet/DownloadApp.vue'
import WarningMessage from 'wap/components/WarningMessage/index.vue'
import LayoutHeader from 'wap/components/Header'
import FirstNavs from 'wap/components/Layout/FirstNavs'
import { Betslip } from 'wap/components/index.js'
import { useLayoutStore } from 'wap/stores/layout'
import chat from '@ms/components/chat/sdk.js'

export default {
  name: 'DefaultLayout',
  components: {
    GlobalContainer,
    DownloadApp,
    WarningMessage,
    LayoutHeader,
    FirstNavs,
    Betslip,
    Broadcast: () => import('./pagelet/Broadcast')
  },
  setup() {
    const { isAppWebview } = storeToRefs(useAppStore())
    const auth = useAuthStore()
    const { loginStatus } = storeToRefs(auth)
    const { pageLoading, noticeMessage, broadcastList } = storeToRefs(useLayoutStore())
    const { loadedConfig } = storeToRefs(useGlobalConfigStore())

    return {
      isAppWebview,
      loginStatus,
      noticeMessage,
      broadcastList,
      pageLoading,
      loadedConfig
    }
  },
  data() {
    return {
      cacheComponentsList: Object.freeze(['SportsBetHistory', 'TradeList', 'GamesRoom', 'PageHome', 'LiveList', 'JackpotHome', 'Sports', 'MatchList', 'CodeTalk'])
    }
  },
  mounted() {
    this.$watch(
      () => this.$route,
      (route) => {
        if (route.name && this.loginStatus) {
          if (route.meta.noPush) {
            unsubUserPush()
          } else {
            subUserPush()
          }
        }
      },
      { immediate: true }
    )
    setTimeout(useMatchLabelsStore().getMatchLabelsInfo, 0)
    chat.init({ zIndex: 99999 })
  },
  beforeDestroy() {
    unsubUserPush()
  }
}
</script>

<style lang="scss">
@import "./layout.scss";
</style>
